import React from 'react'
import { DropTarget } from './plugin'
import DraggableCard from './DraggableCard'
import styles from './DroppableCard.module.css'
import classNames from 'classnames/bind'

const cx = classNames.bind(styles)

const DroppableCard = props => (
  <div className={cx({
    'droppable-item-el': true,
    base: true,
    wrong: props.submitted && props.data.wrong,
  })}>
    <DropTarget dropData={props.data}>
      <div className={styles.label}>
        {props.data.label}
      </div>

      <div className={`droppable-card-el ${styles.card}`}>
        <div className={`droppable-card-droparea-el ${styles.droparea}`}>
          {props.list.map(item => (
            <DraggableCard key={item.id} data={item} {...props.draggable}>{item.labelActive}</DraggableCard>
          ))}
        </div>

        {props.children}
      </div>
    </DropTarget>
  </div>
)

const DroppableCards = props => (
  <div className={`droppable-list-el ${styles.list}`}>
    {props.children}
  </div>
)

DroppableCard.defaultProps = {
  list: [],
}

export default DroppableCard
export { DroppableCards }
